import React from 'react';
import PropTypes from 'prop-types';

import CompanyGridSettings from './company_grid_settings';

export default function CompanyGridsSettings({ company, companyGrids, companyUsers, paths }) {
  return <React.Fragment>
    {companyGrids.map(companyGrid => (
      <CompanyGridSettings
        company={company}
        companyGrid={companyGrid}
        companyUsers={companyUsers}
        key={companyGrid.gridId}
        paths={paths}
      />
    ))}
  </React.Fragment>;
}

CompanyGridsSettings.propTypes = {
  company: PropTypes.object,
  companyGrids: PropTypes.arrayOf(PropTypes.object),
  companyUsers: PropTypes.arrayOf(PropTypes.object),
  paths: PropTypes.object
};
